export type ImpactStatus = "No Impact" | "Impacted" | "";

export type ImpactSubTabKey =
  | "taggingresults"
  | "enhancetaggingresults"
  | "assets"
  | "recommendation"
  | "consolidated";

export interface ImpactSubmission {
  id: string;
  name: string;
  initials: string;
  avatarBg: string;
  time: string;
  analysis: string;
  summary: string;
  recommendation: string;
  other?: string;
  impactLabel: ImpactStatus;
  impactBg: string;
  impactColor: string;
  hasImpact: boolean;
}

export interface ImpactAssessmentRow {
  id: string;
  dimension: string;
  tagValue: string;
  triggeredBy: string;
  analysis: string;
  summary: string;
  recommendation: string;
  impactLabel: ImpactStatus;
  impactBg: string;
  impactColor: string;
  hasImpact: boolean;
  submissions: ImpactSubmission[];
}

export interface EnhanceTaggingRow {
  id: string;
  dimension: string;
  tagValue: string;
  ruleId: string;
  matchingCondition: string;
}

export interface AssetRow {
  rank: number;
  title: string;
  subtitle: string;
  status: string;
  tags: string[];
  score: string;
  relevance: "High" | "Medium" | "Low";
  relBg: string;
  relColor: string;
}

export interface ImpactFormValues {
  impact: ImpactStatus;
  analysis: string;
  summary: string;
  recommendation: string;
}

export const IMPACT_STATUS_STYLES: Record<
  Exclude<ImpactStatus, "">,
  { bg: string; color: string }
> = {
  "No Impact": { bg: "#DCFCE7", color: "#166534" },
  Impacted: { bg: "#FEE2E2", color: "#991B1B" },
};

export const IMPACT_SUB_TABS: { key: ImpactSubTabKey; label: string }[] = [
  { key: "taggingresults", label: "Classification Result" },
  { key: "enhancetaggingresults", label: "Conditional Classification Result" },
  // Temporarily hidden until Assets / Recommendation / Consolidated are ready.
  // { key: "assets", label: "Assets" },
  // { key: "recommendation", label: "Recommendation" },
  // { key: "consolidated", label: "Consolidated" },
];

export const FORM_TEXT_MAX = 1500;
